import React from "react";
import { Dropdown } from "react-bootstrap";
import "./FilterDropdown.css";

export default function FilterDropdown({
    alwaysShow,
    title,
    dropdownTitle,
    onClick,
    onClickInitial,
    onClickItem,
    items,
    filterHeader,
    disabled,
}) {
    let disabledCss = disabled ? "cool" : "";
    let visibilityCss = "w-100 " + disabledCss;    
    return (
        <Dropdown className={visibilityCss}>
            {/* If no dropdown should be shown, and instead taking over the click */}
            {typeof onClick == "function" ? (
                <Dropdown.Toggle className="w-100" onClick={onClick}>
                    {title ?? dropdownTitle}
                </Dropdown.Toggle>
            ) : (
                <Dropdown.Toggle className="w-100">{title ?? dropdownTitle}</Dropdown.Toggle>
            )}

            {items && filterHeader != "KATEGORIER" && (
                <Dropdown.Menu
                    className={"dropdown-menu " + dropdownTitle}
                    data-popper-placement="bottom-start"
                    x-placement="bottom-start"
                    data-bs-toggle="dropdown"
                    data-bs-display="static"
                >
                    <Dropdown.Item onClick={() => onClickInitial()}>{dropdownTitle}</Dropdown.Item>
                    {items
                        .sort((a, b) => {
                            return a.value.localeCompare(b.value);
                        })
                        .map((item) => {
                            return (
                                <Dropdown.Item
                                    key={item.value}
                                    onClick={() => {
                                        onClickItem(item.value);                                       
                                    }}
                                >
                                    {item.value}
                                </Dropdown.Item>
                            );
                        })}
                </Dropdown.Menu>
            )}
            {items && filterHeader === "KATEGORIER" && (
                <Dropdown.Menu
                    className={"dropdown-menu " + dropdownTitle}
                    data-popper-placement="bottom-start"
                    data-bs-display="static"
                    x-placement="bottom-start"
                    data-bs-toggle="dropdown"
                >
                    <Dropdown.Item onClick={() => onClickInitial()}>{dropdownTitle}</Dropdown.Item>
                    {items
                        .sort((a, b) => {
                            return b.$id.localeCompare(a.$id);
                        })
                        .map((item) => {
                            return (
                                <>
                                    {item.value != "Okänd" && item.value &&(
                                        <Dropdown.Item
                                            key={item.value}
                                            onClick={() => {
                                                onClickItem(item.value);                                              
                                            }}
                                        >
                                            {item.value}
                                        </Dropdown.Item>
                                    )}
                                </>
                            );
                        })}
                </Dropdown.Menu>
            )}
        </Dropdown>
    );
}
